import i18n from "i18next";

// Editörün o anki UI dilini (i18n.language: "tr"/"en"/"es"...) örnek ses
// dosyalarının dil kodu adaylarına çevirir. Örnek ses, açık olan editör/sayfa
// diline göre çalsın diye sample seçiminde en yüksek öncelikte kullanılır.
// (AIVoiceTab'daki editorLanguageSampleCandidates ile aynı.)
export const editorLanguageSampleCandidates = () => {
  let stored = "";
  try {
    stored = localStorage.getItem("i18nextLng") || "";
  } catch (e) {
    stored = "";
  }
  const base = String(i18n.language || stored || "")
    .toLowerCase()
    .split("-")[0];
  const map = {
    tr: ["tr-TR", "tr"],
    en: ["en-US", "en-GB", "en"],
    es: ["es-ES", "es"],
    de: ["de-DE", "de"],
    fr: ["fr-FR", "fr"],
    ja: ["ja-JP", "ja"],
    zh: ["zh-CN", "zh"],
    az: ["az-AZ", "az"],
    pt: ["pt-BR", "pt"],
    ar: ["ar-SA", "ar"],
  };
  return map[base] || (base ? [base] : []);
};

// Bir sesin sampleUrlsByLanguage anahtarları içinden çalınacak dili seçer.
// Öncelik (AIVoiceTab.handleSamplePlay ile aynı):
//   1. manuel seçilen sample dili (sampleLanguage)
//   2. açık olan editör/sayfa dili (editorLanguageSampleCandidates)
//   3. Türkçe (tr-TR, tr)
//   4. İngilizce (en-US, en-GB, en)
//   5. seçili üretim dili (selectedLanguage)
//   6. ilk mevcut dil
export const pickSampleLanguage = (
  availableLanguages,
  { sampleLanguage = "", selectedLanguage = "" } = {}
) => {
  if (!Array.isArray(availableLanguages) || availableLanguages.length === 0) return null;

  if (sampleLanguage && availableLanguages.includes(sampleLanguage)) {
    return sampleLanguage;
  }

  for (const lang of editorLanguageSampleCandidates()) {
    if (availableLanguages.includes(lang)) return lang;
  }

  for (const lang of ["tr-TR", "tr"]) {
    if (availableLanguages.includes(lang)) return lang;
  }

  for (const lang of ["en-US", "en-GB", "en"]) {
    if (availableLanguages.includes(lang)) return lang;
  }

  if (selectedLanguage && availableLanguages.includes(selectedLanguage)) {
    return selectedLanguage;
  }

  return availableLanguages[0];
};
